export default "__VITE_ASSET__D6PhcF7f__"